import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";

const action = new ReduxActionNameCreator("loading");

export const SHOW_LOADING = action.make("show");
export const HIDE_LOADING = action.make("hide");

export const showLoading = () => ({ type: SHOW_LOADING });
export const hideLoading = () => ({ type: HIDE_LOADING });
